export const FETCH_APPOINTMENTLIST_REQUEST = "FETCH_APPOINTMENTLIST_REQUEST";
export const FETCH_APPOINTMENTLIST_SUCCESS = "FETCH_APPOINTMENTLIST_SUCCESS";
export const FETCH_APPOINTMENTLIST_FAILURE = "FETCH_APPOINTMENTLIST_FAILURE";
